import React from 'react';
import { Spinner } from 'react-bootstrap';

import styles from './styles.module.scss';

const Loader: React.FC = () => (
  <div className={styles.container}>
    <Spinner animation="border" variant="primary" />
  </div>
);

export default Loader;
